import React from "react";
import { connect } from "react-redux";
import { Outlet } from "react-router-dom";
import moment from "moment";
import "moment/locale/ru";
import "moment/locale/uk";
import { Container } from "../../../style/grid";
import Header from "../../components/Header/Header";
import Sider from "../../components/Sider/Sider";
import { NetworkErrorPopup } from "../../components/ui/NetworkErrorPopup/NetworkErrorPopup";
import { useEffect } from "react";
import { wsConnected, wsDisconnected } from "../../../redux/chat/actions";
import ConsultationsReport from "../ConsultationsReport/ConsultationsReport";
import { roleIs } from "../../../helpers/functions";
import "./Home.scss";

const Home = ({
  wsConnected,
  wsDisconnected,
  role,
}) => {
  
  useEffect(() => {
    const lang = localStorage.getItem("i18nextLng")?.slice(0, 2) || "uk";
    moment.locale(lang);
    
    wsConnected()
    return () => wsDisconnected()
  }, [])

  return (
    <main>
      <div className="mainRowBox">
        <Sider role={role}/>
        <div className="content">
          <Header role={role}/>
          <NetworkErrorPopup />
          <div className="contentContainer">
            <Outlet />
          </div>
        </div>
      </div>
    </main>
  );
};

const mapStateToProps = ({ user }) => {
  // Get the role from the roles array - prioritize admin role if present
  const roles = user?.roles || [];
  let role = '';
  
  if (roles.includes('ROLE_ADMIN')) {
    role = 'admin';
  } else if (roles.includes('ROLE_INSURANCE_ADMIN')) {
    role = 'insurance-admin';
  } else if (roles.includes('ROLE_DIVISION_ADMIN')) {
    role = 'division-admin';
  } else if (roles.includes('ROLE_OPERATOR')) {
    role = 'operator';
  } else if (roles.includes('ROLE_INSURANCE_OPERATOR')) {
    role = 'insurance-operator';
  } else if (roles.includes('ROLE_DOCTOR')) {
    role = 'doctor';
  }

  return { role };
};

export default connect(mapStateToProps, {
  wsConnected,
  wsDisconnected,
})(Home);
